<script>
import SaleInfoModal from '@/views/SaleSite/SaleInfoModal.vue';
import OrderModal from '@/views/SaleSite/OrderModal.vue';

export default {
    components: {
        SaleInfoModal,
        OrderModal
    },
    created() {  
       
    },
    data() {
        return {  
            hasScrolledOnce: false,
            selectedSlide: 0,
            sliderInterval: null,
            showModal: false,
            modalTitle: '',
            modalContent: '',
            modalBackgroundColor: '#124c3d',
            showOrderModal: false,
            orderVersion: 's'
        }
    },
    methods:
    {
        openModal(title, content, backgroundColor = '#124c3d') {
           
            this.modalTitle = title;
            this.modalContent = content;
            this.modalBackgroundColor = backgroundColor;
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.modalTitle = '';
            this.modalContent = '';
            this.modalBackgroundColor = '#124c3d';
        },
        openOrderModal(version) {
            this.orderVersion = version;
            this.showOrderModal = true;
        },
        closeOrderModal() {
            this.showOrderModal = false;
        },
        scrollToSection() {
            const scrollDistance = window.innerHeight * 0.5; 
            $("html, body").animate({ scrollTop: scrollDistance });
            this.hasScrolledOnce = true;
        },
        scrollToFourReasons() {
            const element = document.getElementById('four_good_reasons');
            if (element) {
                window.scrollTo({
                    top: element.offsetTop - 100,
                    behavior: 'smooth'
                });
            }
        },      
    },
    computed: {
        height() { return window.innerHeight + 'px' },
    }
}
</script>
<template>
    <section>
        <div id="happy_girl" :style="{'height': height }">
            <div id="dotted_dress" :style="{'height': height }"></div>
            <!-- <img src="@/assets/imgs/sale/dotted_dress_2.png">             -->
        </div>
        <div id="banana_box">
            <div>
                <h1>VAD ÄR JAMII?</h1>
                <blockquote>Den digitala plattformen som förenar er gemenskap och förenklar vardagen för alla medlemmar.</blockquote>
                <p>JAMII är den kompletta lösningen för föreningar, samfälligheter och kontorshotell som vill bygga starkare gemenskap och effektivare administration.</p>
                <p>Med allt från professionella hemsidor och smidiga bokningssystem till kraftfull kommunikation och engagerande funktioner - JAMII samlar er verksamhet på ett ställe.</p>
                <button @click="openModal('Vad är JAMII?', 'JAMII är den kompletta digitala plattformen som förenar alla delar av er verksamhet på ett ställe. Oavsett om ni driver en bostadsrättsförening, samfällighet, ideell förening eller kontorshotell - JAMII förenklar vardagen för både styrelse och medlemmar. \n\nMed JAMII får ni en professionell hemsida, smidiga bokningssystem, effektiv kommunikation och alla verktyg ni behöver för att skapa engagemang. Slipp jonglera mellan olika system och mejllistor. JAMII samlar allt digitalt så ni kan fokusera på det som verkligen spelar roll - er gemenskap och verksamhet. \n\nTusentals föreningar har redan upptäckt fördelarna med att ha allt samlat i en lättanvänd plattform. Bli nästa framgångshistoria!', '#124c3d')">Läs mer här</button>
            </div>
            <img src="@/assets/imgs/sale/banana_box.png" class="">
        </div>
        <div id="four_good_reasons">
            <h1 class="text-center">4 goda <span style="color:#05322a">anledningar att<br> välja</span> JAMII</h1>
            <div class="boxes">
                <div id="girl-with-phone">
                    <img src="@/assets/imgs/sale/looking_on_phone.png">
                    <h5>Viktig information som inte når fram? <br><br> Det löser JAMII!</h5> 
                    <button @click="openModal('Viktig information som inte når fram?', 'Slut på missad information och förvirring! Med JAMII:s kraftfulla kommunikationsverktyg når ni ut till alla medlemmar på ett säkert och effektivt sätt. \n\nAnvänd vårt aktuelltflöde för att dela nyheter, påminnelser och viktiga meddelanden som alla ser direkt när de loggar in. Skicka riktade meddelanden till specifika grupper eller alla medlemmar samtidigt. Alla kan enkelt hålla sig uppdaterade via webb eller mobil. \n\nMed läskvitton ser ni vem som tagit del av informationen, och påminnelsefunktionen säkerställer att inget viktigt missas. JAMII sparar även all kommunikation så ni alltid kan gå tillbaka och hitta tidigare meddelanden. \n\nSlipp mejlkaos, utskick som hamnar i skräppost och osäkerhet om informationen nått fram. Med JAMII når ni alla, alltid.', '#05322a')">Läs mer</button>                  
                </div>
                <div id="map">
                    <img src="@/assets/imgs/sale/white_sweden.png">
                    <section style="float: right; width: 60%">
                        <h5>Svårt att nå ut till fler med er verksamhet?<br><br> Det löser JAMII!</h5>
                        <button class="float-right" style="margin-right: 10px;" @click="openModal('Svårt att nå ut till fler med er verksamhet?', 'Gör er verksamhet synlig för fler med JAMII:s inbyggda marknadsföringsverktyg! Er professionella hemsida blir automatiskt sökbar på Google och visar upp allt det fantastiska ni gör. \n\nDela enkelt bilder, aktiviteter och evenemang via bildgalleriet och aktuelltflödet. Potentiella nya medlemmar kan se er verksamhet live och få känslan av gemenskap redan innan de går med. Social delning gör att era medlemmar sprider ordet vidare till sina nätverk. \n\nMed JAMII:s bokningssystem kan ni öppna upp aktiviteter och lokaler för externa besökare, vilket skapar nya intäktsströmmar och synlighet. Era medlemmar blir era bästa ambassadörer när de enkelt kan bjuda in vänner till aktiviteter. \n\nVi hjälper er att växa naturligt genom att göra det lätt att upptäcka och engagera sig i er verksamhet.', '#c5e0f1')">Läs mer</button> 
                    </section>
                </div>               
            </div>
            <div class="boxes">
                <div id="yellow">             
                        <h5>Svårt att engagera sig?<br><br>Det löser JAMII!</h5>
                        <button class="float-right" @click="openModal('Svårt att engagera sig?', 'Skapa liv och rörelse i er förening med JAMII:s engagemangsverktyg! Våra arbetsgrupper gör det enkelt för medlemmar att hitta sitt sätt att bidra - oavsett om det gäller trädgårdsgruppen, festkommittén eller styrelsearbete. \n\nMed det interaktiva aktuelltflödet kan medlemmar kommentera, reagera och diskutera - precis som på sociala medier men i er trygga, slutna miljö. Skapa enkelt evenemang som medlemmar kan anmäla sig till direkt via plattformen. \n\nVårt medlemsregister hjälper till att matcha personer med liknande intressen, och genom att låta alla bidra med bilder och innehåll skapas en levande gemenskap där alla känner sig delaktiga. \n\nJAMII gör det roligt och lätt att vara aktiv medlem. När deltagande blir enkelt, växer engagemanget naturligt och ni får en mer levande förening som alla trivs i.', '#f4e76e')">Läs mer</button> 
                    
                    <img src="@/assets/imgs/sale/woman_jumping.png">

                </div>
                <div id="red-bg">
                    <h5 style="width: auto;">Delade prylar - men när kan man använda dem?<br><br>
                        Det löser JAMII!
                    </h5>
                    <button @click="openModal('Delade prylar - men när kan man använda dem?', 'Säg hejdå till dubbelbokning och förvirring! JAMII:s smarta bokningssystem håller koll på allt som kan bokas - från tvättstugan och gästlägenheten till låneutrustning och gemensamma lokaler. \n\nMedlemmar ser direkt vad som är ledigt och kan boka med några klick. Automatiska påminnelser ser till att alla kommer ihåg sina bokningar, och tydliga regler för varje resurs förhindrar missförstånd. \n\nSystemet hanterar även väntlistor, återkommande bokningar och speciella villkor. Som administratör får ni full översikt med rapporter över användning och kan enkelt hantera avbokningar eller konflikter. \n\nOavsett om det gäller en elcykel, festlokal eller verktyg - med JAMII blir delning av resurser smidigt istället för stressigt. Era medlemmar får bättre tillgång till det de behöver, och ni slipper administration och klagomål.', '#f25c43')">Läs mer</button>              
                </div> 
            </div>
        </div>
        <div id="created_with_jamii">
            <h1 class="text-center">SKAPAT MED JAMII</h1>
            <div class="created_with_jamii_area">
                <div>
                    <img src="@/assets/imgs/sale/created1.png" />
                    <h2>Förening</h2>
                    <a class="margin-top-15" href="https://www.jamii.se/jamii-samfallighetsforening" target="_blank">Visa Exempel</a>
                </div>
                <div>
                    <img src="@/assets/imgs/sale/created2.png" />
                    <h2>Verksamhet</h2>
                    <a class="margin-top-15" href="https://www.jamii.se/jamii-yoga" target="_blank">Visa Exempel</a>
                </div>
                <div>
                    <img src="@/assets/imgs/sale/created3.png" />
                    <h2>Kontor</h2>
                    <a class="margin-top-15" href="https://www.jamii.se/jamii-kontorshotell" target="_blank">Visa Exempel</a>
                </div>
            </div>
        </div>
        <div id="our_products">
            <h1 class="text-center">Våra Produkter</h1>
            <div class="our_products_area">
                <div>
                    <img src="@/assets/imgs/sale/logo_empty.png">
                    <span>
                        PRIS
                    </span>
                    <span>
                        ANVÄNDARE
                    </span>
                    <span>
                        PUBLIK HEMSIDA
                    </span>
                    <span>
                        BOKNINGSSTÖD
                    </span>
                    <span>
                        KURSSTÖD
                    </span>
                    <span>
                        BILDGALLERI
                    </span>
                    <span>
                        AKTUELLTFLÖDE
                    </span>
                    <span>
                        MEDLEMSREGISTER
                    </span>
                    <span>
                        DOKUMENTHANTERING
                    </span>
                    <span>
                        SKICKA INBJUDAN
                    </span>
                    <span>
                        ARBETSGRUPPER
                    </span>
                </div>
                <div>
                    <img src="@/assets/imgs/sale/jamii_logo_jante.png">
                    
                    <span>
                        <b>150</b> kr/mån
                    </span>
                    <span>
                        <b>50</b>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        -
                    </span>
                    <span>
                        -
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        -
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        -
                    </span>
                   
                    <button @click="openOrderModal('s')">Beställ</button>
                </div>
                 <div class="mobile-only">
                    <img src="@/assets/imgs/sale/logo_empty.png">
                    <span>
                        PRIS
                    </span>
                    <span>
                        ANVÄNDARE
                    </span>
                    <span>
                        PUBLIK HEMSIDA
                    </span>
                    <span>
                        BOKNINGSSTÖD
                    </span>
                    <span>
                        KURSSTÖD
                    </span>
                    <span>
                        BILDGALLERI
                    </span>
                    <span>
                        AKTUELLTFLÖDE
                    </span>
                    <span>
                        MEDLEMSREGISTER
                    </span>
                    <span>
                        DOKUMENTHANTERING
                    </span>
                    <span>
                        SKICKA INBJUDAN
                    </span>
                    <span>
                        ARBETSGRUPPER
                    </span>
                </div>
                <div>
                    <img src="@/assets/imgs/sale/jamii_logo_lagom.png">                   
                    <span>
                        <b>300</b> kr/mån
                    </span>
                    <span>
                        <b>300</b>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                        
                    </span>
                   
                    <button @click="openOrderModal('m')">Beställ</button>

                </div>
                 <div class="mobile-only">
                    <img src="@/assets/imgs/sale/logo_empty.png">
                    <span>
                        PRIS
                    </span>
                    <span>
                        ANVÄNDARE
                    </span>
                    <span>
                        PUBLIK HEMSIDA
                    </span>
                    <span>
                        BOKNINGSSTÖD
                    </span>
                    <span>
                        KURSSTÖD
                    </span>
                    <span>
                        BILDGALLERI
                    </span>
                    <span>
                        AKTUELLTFLÖDE
                    </span>
                    <span>
                        MEDLEMSREGISTER
                    </span>
                    <span>
                        DOKUMENTHANTERING
                    </span>
                    <span>
                        SKICKA INBJUDAN
                    </span>
                    <span>
                        ARBETSGRUPPER
                    </span>
                </div>
                <div>
                    <img src="@/assets/imgs/sale/jamii_logo_markvardig.png">
                    <span>
                        <b>Från 700</b> kr/mån 
                    </span>
                    <span>
                     <b> >300 </b>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>                   
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>                                                           
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>                                                  
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>                                                          
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>                                                
                    </span>
                    <span>
                        <i class="fa-solid fa-check"></i>   
                    </span>
                    
                    <button @click="openOrderModal('l')">Beställ</button>
                </div>
            </div>
        </div>
    </section>
    <SaleInfoModal :isVisible="showModal" :title="modalTitle" :content="modalContent" :backgroundColor="modalBackgroundColor" @close="closeModal"></SaleInfoModal>
    <OrderModal :isVisible="showOrderModal" :orderVersion="orderVersion" @close="closeOrderModal"></OrderModal>
</template>
<style scoped>
#happy_girl {
    background-image: url('@/assets/imgs/sale/yellow_bg.jpg');
    overflow:hidden;
}

#happy_girl img {
    position: absolute;
    width:100%;
    bottom: 0px;
    right: 0px;
}

#dotted_dress {
    background-image: url('@/assets/imgs/sale/dotted_dress_2.png');
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100vh;
}

#banana_box {
    background-color: #124c3d;
    background-image: url('@/assets/imgs/sale/dotted_sweden.png');
    background-repeat: no-repeat;
    background-size: 80%;
    background-position: center;
    color: white;
    position: relative;
    overflow: auto;
    min-height: 400px;
}

#banana_box img {
    position: absolute;
    width:35%;
    bottom: 0px;
    left: 6vw;
}

#banana_box div {
    width: calc(50% - 70px);
    float: right;
    margin: 100px 40px 50px 30px;
}

#banana_box button {
    margin-top: 50px;
}

#four_good_reasons {
    background-image: url('@/assets/imgs/sale/good_reason_bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
    color: white;
    padding:10px 0px 270px 0px;
}

#four_good_reasons h1 {
    margin-bottom: 97px;
}

#four_good_reasons .boxes {
   display: flex;
   flex-wrap: nowrap;
   justify-content: center;
}

#four_good_reasons p {
    font-style: normal;
    font-size: 20pt;
    margin: 20px 0px 5px 20px;
}

#four_good_reasons li {
    font-style: normal;
    font-size: 20pt;
    padding: 5px;
    margin-left:10px;
}

#four_good_reasons .boxes #yellow {
    background-image: url('@/assets/imgs/sale/yellow_rectangle.png');
    width:25%;
}

#four_good_reasons .boxes #yellow h5 {
    font-size: 3vw; float: right; text-align: right; width: 80%
}


#four_good_reasons .boxes #yellow img {
    position: absolute; bottom: -2vw; left: -10vw; width:73%;
}

#four_good_reasons .boxes #girl-with-phone {   
    width:45%;
    background-color: #05322a
}

#four_good_reasons .boxes #girl-with-phone img {
    position: absolute; bottom: 0px; right: 10px; width: 46%;
}

#four_good_reasons .boxes #map {   
    width:25%; 
    background-color: #c5e0f1
}

#four_good_reasons .boxes #map h5 {   
    font-size: 2.2vw; text-align: right; width: 80%;
}

#four_good_reasons .boxes #map img {   
    position: absolute; 
    top: -3vw; 
    left: -1vw; 
    z-index:10; 
    width: 56%;
}

#four_good_reasons .boxes #red-bg {   
    width:45%; 
    background-color: #f25c43;
}

#four_good_reasons .boxes div {
   margin:10px;
   border-radius: 30px;
   padding:10px;
   position: relative;
}

#created_with_jamii{
    background-color: #e0d9bd;
    padding-top: 30px;
    padding-bottom: 90px;
    overflow: auto;
    color: #063227;
}

.created_with_jamii_area
{
    width: 80%;
    margin: auto;
    display:flex;
    justify-content: center;
}

.created_with_jamii_area div
{
    margin: 10px;
    text-align: center;
    width: calc(33% - 20px);
}

.created_with_jamii_area img
{
    width: 100%;
}

.our_products_area
{
    margin: auto;
    margin-top: 60px;
    margin-bottom:150px;
    display:flex;
    justify-content: center;
    margin-top: 60px;
    width: 90%;
}

.our_products_area_headers
{
    margin-top: 114px !important;
    text-align: left !important;
}


.our_products_area div {
    margin: 0px;
    width: 25%;
    text-align: center;
}

.our_products_area img {
    width: 70%;
}

.our_products_area span {
    display: block;
    width: 100%;
    border-bottom: 1px solid white;
    margin-top: 33px;
    padding-bottom: 15px;
    font-size: 19px;
}

.our_products_area button{
    margin-bottom: 0px;
    background-color: #05322a;
}

#our_products {
    padding-top: 30px;
    background-image: url('@/assets/imgs/sale/red_bg.jpg');
    background-repeat: no-repeat;  
    background-position: center;
    background-size: cover;
    color: white;
    width: 100%;
    overflow: auto;
}

.our_products_area a {
    color: black !important;
    background: white !important;
    border-color: black !important;
}


div{
    opacity: 1;
}

h1 {
    font-family: "Barlow Condensed", serif;
    font-weight: 700;
    font-style: normal;
    font-size: 6vw;
    margin-bottom:27px;
    text-transform: none;
}

h2 {
    font-family: "Barlow Condensed", serif;
    font-weight: 600;
    font-style: normal;
    font-size: 4vw;
    margin-bottom:22px;
    text-transform: none;
}

h5 {
    font-family: "Barlow Condensed", serif;
    font-weight: 600;
    font-style: normal;
    font-size: 3vw;
    width: 51%;
    /* font-size: 35pt; */
    margin: 30px 10px 5px 30px;
    text-transform: none;
}

.mobile-only {
    display: none;
}

blockquote
{
    font-weight: 600;
    font-size: 14pt;
    margin: 0px 0px 15px 0px;
    display: block;
    border-left: 0px solid black;
    padding: 0px;
}

p {
    font-weight: 400;
    font-size: 13pt;
    margin-top: 20px;
    display:block;
}

button,
.created_with_jamii_area a,
.our_products_area a
{
border-radius: 31px;
margin: 20px 7px;
padding: 12px 30px;
border: 2px solid rgb(0, 0, 0);
font-family: "Poppins", sans-serif;
font-weight: 500;
text-transform: uppercase;
font-size: 1.2vw;
background-color: #f25c43;
color: white;
border-color: #f25c43;
display:inline-block;
cursor: pointer;
transition: all 0.3s ease;
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

button:hover,
.created_with_jamii_area a:hover,
.our_products_area a:hover {
transform: translateY(-2px);
box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
background-color: #e04a35;
border-color: #e04a35;
}

button:active,
.created_with_jamii_area a:active,
.our_products_area a:active {
transform: translateY(0px);
box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
transition: all 0.1s ease;
}

/* Special styling for white buttons */
button[style*="background-color: white"]:hover {
background-color: #f0f0f0 !important;
color: #063227 !important;
transform: translateY(-2px);
box-shadow: 0 4px 15px rgba(6, 50, 39, 0.15);
}

button[style*="background-color: white"]:active {
background-color: #e5e5e5 !important;
transform: translateY(0px);
box-shadow: 0 2px 8px rgba(6, 50, 39, 0.1);
}


/* Responsive */
@media (max-width: 800px) {
    h1 {   
        font-size: 9vw;
    }

    .mobile-only {
    display: block;
    }
    .boxes {
        flex-direction: column;
        align-items: center;
    }
    #banana_box {
        overflow: hidden;
    }
    #banana_box img {
        position:relative;
        width: 70%;
        display: block;
        margin: 0 auto;
        margin-bottom: -2px;
        left:auto;
    }

    #banana_box div {
        width: calc(100% - 70px);
        float: right;
        margin: 50px 40px 20px 30px;
    }
    
    #banana_box button {
        font-size: 14px;
    }

    
    #four_good_reasons h1 {
        margin-bottom: 27px;
    }

    #four_good_reasons button {
        font-size: 14px;
    }

    #four_good_reasons .boxes #yellow {
    background-image: url('@/assets/imgs/sale/yellow_rectangle.png');
    width:80%;
    }

    #four_good_reasons .boxes #yellow h5 {
        font-size: 7vw;
    }
    
    #four_good_reasons .boxes #yellow img {
        width: 54%;
        z-index: 20;
        left: -12vw;
    }

    #four_good_reasons .boxes #girl-with-phone {   
        width:80%;
        background-color: #05322a
    }
    
    #four_good_reasons .boxes #girl-with-phone h5 {   
        font-size: 6vw;
    }

    #four_good_reasons .boxes #girl-with-phone img {
        width: 42%;
    }

    #four_good_reasons .boxes #map {   
        width:80%; 
        background-color: #c5e0f1;
        overflow: hidden;
    }

    #four_good_reasons .boxes #map img {    
        margin-top: -20vw;
        left: -3vw;
    }
    #four_good_reasons .boxes #map h5 {    
        font-size: 6vw;
    }

    #four_good_reasons .boxes #red-bg {   
        width:80%; 
        background-color: #f25c43;
    }
    
    #four_good_reasons .boxes #red-bg h5 {   
       font-size: 7vw;
    }

    .created_with_jamii_area {
        flex-direction: column;
        align-items: center;
    }

    .created_with_jamii_area div {
        width:80%;
    }
    .created_with_jamii_area a {
        font-size:14px;
    }
    
    .created_with_jamii_area h2 {
        font-size:8vw;
    }

    #dotted_dress {
        background-image: url('@/assets/imgs/sale/dotted_dress_mobile.png');
        width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: bottom;  
        background-position-x: right;
    }

    .our_products_area {
         flex-wrap: wrap;
    
    }
    .our_products_area div {
        width: 50%;
       
    }
    .our_products_area img {
        margin-left: -100%;
        width:100%;     
    }

    .our_products_area button{
     font-size: 15px;
     margin-bottom:40px;
}

}
</style>
